module.exports = __webpack_public_path__ + "static/media/Group 2 copying.8fae38e3.png";